import { LocaleCode } from '@language';
import { ExportLocation } from '../../exports/entities/export-location.entity';
import { Group } from '../../groups/entities/group.entity';
import { Organisation } from '../../organisations/entities/organisation.entity';
import { Role } from '../../roles/entities/role.entity';
import { Zone } from '../../zones/entities/zone.entity';

enum UserIdBrand {
    _ = ''
}
export type UserId = string & UserIdBrand;

export class UserDetails {
    FirstName: string;
    LastName: string;
    Email?: string;
    Locale: LocaleCode;
}
export class User extends UserDetails {
    Id: UserId;
    Login: string;
    Organisation: Organisation;
    Rights: UserRights;
    Roles: Role[];
    Groups: Group[];
    IsSystem: boolean;
    TenantGroup: string;
    Type: UserType;
    AuthorizationType: UserAuthorizationType;
    Context: {
        IsEditable: boolean;
        ArePreferencesEditable: boolean;
    };
    LastLoginDate?: string;
}

export interface UserRights {
    WriteRights: boolean;
    DeleteRights: boolean;
    ExportRights: boolean;
    ReadRights: boolean;
}

export class ExtendedUser extends User {
    Zones: Zone[];
    ExportLocations: ExportLocation[];
}

export interface ReadonlyUser extends ExtendedUser {
    LocaleString: string;
}

export enum UserType {
    'MEDIAHAVEN' = 'Mediahaven',
    'OAUTH' = 'Oauth',
    'LDAP' = 'Ldap',
    'SAML' = 'Saml'
}

export enum UserAuthorizationType {
    'NORMAL' = 'Normal',
    'APPLICATION' = 'Application',
    'PUBLIC' = 'Public',
    'ZETICONPRIMARYORGANISATION' = 'ZeticonPrimaryOrganisation',
    'ZETICONSECONDARYORGANISATION' = 'ZeticonSecondaryOrganisation',
    'ZETICONALLORGANISATIONS' = 'ZeticonAllOrganisations',
    'SYSTEM' = 'System',
    'SYSTEMALLORGANISATIONS' = 'SystemAllOrganisations'
}
